const iconClassName = "shrink-0";

const ValidatedStatusIcon = () => (
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={iconClassName}
    aria-hidden
  >
    <path
      d="M3.8 8.01667L0 4.21667L0.95 3.26667L3.8 6.11667L9.91667 0L10.8667 0.95L3.8 8.01667Z"
      fill="currentColor"
    />
  </svg>
);

const WarningStatusIcon = () => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={iconClassName}
    aria-hidden
  >
    <path
      d="M0 12.6667L7.33333 0L14.6667 12.6667H0ZM2.3 11.3333H12.3667L7.33333 2.66667L2.3 11.3333ZM7.33333 10.6667C7.52222 10.6667 7.68056 10.6028 7.80833 10.475C7.93611 10.3472 8 10.1889 8 10C8 9.81111 7.93611 9.65278 7.80833 9.525C7.68056 9.39722 7.52222 9.33333 7.33333 9.33333C7.14444 9.33333 6.98611 9.39722 6.85833 9.525C6.73056 9.65278 6.66667 9.81111 6.66667 10C6.66667 10.1889 6.73056 10.3472 6.85833 10.475C6.98611 10.6028 7.14444 10.6667 7.33333 10.6667ZM6.66667 8.66667H8V5.33333H6.66667V8.66667Z"
      fill="currentColor"
    />
  </svg>
);

const ToProcessStatusIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={iconClassName}
    aria-hidden
  >
    <path
      d="M6.51905 13.3333C4.94127 13.3333 3.5496 12.85 2.34405 11.8833C1.13849 10.9167 0.363492 9.68333 0.0190476 8.18333C-0.0253968 7.99444 0.00793651 7.825 0.119048 7.675C0.230159 7.525 0.380159 7.43889 0.569048 7.41667C0.757937 7.39444 0.924603 7.43889 1.06905 7.55C1.21349 7.66111 1.31349 7.81111 1.36905 8C1.66905 9.16667 2.29405 10.125 3.24405 10.875C4.19405 11.625 5.28571 12 6.51905 12C8.00794 12 9.26905 11.4833 10.3024 10.45C11.3357 9.41667 11.8524 8.15556 11.8524 6.66667C11.8524 5.17778 11.3357 3.91667 10.3024 2.88333C9.26905 1.85 8.00794 1.33333 6.51905 1.33333C5.56349 1.33333 4.67738 1.56944 3.86071 2.04167C3.04405 2.51389 2.39683 3.16667 1.91905 4H3.18571C3.3746 4 3.53294 4.06389 3.66071 4.19167C3.78849 4.31944 3.85238 4.47778 3.85238 4.66667C3.85238 4.85556 3.78849 5.01389 3.66071 5.14167C3.53294 5.26944 3.3746 5.33333 3.18571 5.33333H0.919048C0.674603 5.33333 0.480159 5.23611 0.335714 5.04167C0.19127 4.84722 0.157937 4.63889 0.235714 4.41667C0.702381 3.10556 1.50794 2.04167 2.65238 1.225C3.79683 0.408333 5.08571 0 6.51905 0C7.44127 0 8.30794 0.175 9.11905 0.525C9.93016 0.875 10.6357 1.35 11.2357 1.95C11.8357 2.55 12.3107 3.25556 12.6607 4.06667C13.0107 4.87778 13.1857 5.74444 13.1857 6.66667C13.1857 7.58889 13.0107 8.45556 12.6607 9.26667C12.3107 10.0778 11.8357 10.7833 11.2357 11.3833C10.6357 11.9833 9.93016 12.4583 9.11905 12.8083C8.30794 13.1583 7.44127 13.3333 6.51905 13.3333ZM7.18571 6.4L8.85238 8.06667C8.9746 8.18889 9.03572 8.34444 9.03572 8.53333C9.03572 8.72222 8.9746 8.87778 8.85238 9C8.73016 9.12222 8.5746 9.18333 8.38571 9.18333C8.19683 9.18333 8.04127 9.12222 7.91905 9L6.05238 7.13333C5.98571 7.06667 5.93571 6.99167 5.90238 6.90833C5.86905 6.825 5.85238 6.73889 5.85238 6.65V4C5.85238 3.81111 5.91627 3.65278 6.04405 3.525C6.17183 3.39722 6.33016 3.33333 6.51905 3.33333C6.70794 3.33333 6.86627 3.39722 6.99405 3.525C7.12183 3.65278 7.18571 3.81111 7.18571 4V6.4Z"
      fill="currentColor"
    />
  </svg>
);

const InterrogationStatusIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={iconClassName}
    aria-hidden
  >
    <path
      d="M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM7 12.6667C3.87033 12.6667 1.33333 10.1297 1.33333 7C1.33333 3.87033 3.87033 1.33333 7 1.33333C10.1297 1.33333 12.6667 3.87033 12.6667 7C12.6667 10.1297 10.1297 12.6667 7 12.6667ZM6.58333 9.91667H7.41667V9.08333H6.58333V9.91667ZM7 8.16667C7.55208 8.16667 8 7.71875 8 7.16667C8 6.34375 7.4375 5.85417 6.77083 5.4375C6.20833 5.08333 5.83333 4.70833 5.83333 4.08333H6.66667C6.66667 4.52083 6.95833 4.77083 7.4375 5.0625C8.04167 5.4375 8.83333 5.95833 8.83333 7.16667C8.83333 8.20312 8.02604 8.16667 7 8.16667Z"
      fill="currentColor"
    />
  </svg>
);

const STATUS_ICON_BY_KEY = {
  validated: ValidatedStatusIcon,
  toProcess: ToProcessStatusIcon,
  interrogation: InterrogationStatusIcon,
  warning: WarningStatusIcon,
};

export const CollectionStatusIcon = ({ statusIcon }) => {
  const IconComponent = STATUS_ICON_BY_KEY[statusIcon];
  if (!IconComponent) return null;
  return <IconComponent />;
};
